import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import Moment from "moment";
import React, { Component } from "react";
import { Button, Col, Form, Row, Nav } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { PacmanLoader } from 'react-spinners';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

let defaultState = {
    searching: false,
    isLoading: true,
    sales: [],
    filter: {},
    showAlert: false,
    errorMessage: "",
    savingNewRecord: false,
    feeddate: null, 
    feedDateOptions: [],
    selectedFeedDate: null,
    cityscope: null,
    streetname: '',
    suburb: '',
    state: null, 
    matched: null, 
    keyed: null, 
    saledatefrom: null, 
    saledateto:  null, 
    id: '',
    salepricefrom: '', 
    salepriceto: '', 
    transfernumber: '',                         
    checkedby: '',                         
    selectedCityscope: null,
    selectedKeyed: {value: null, label: "Both"},
    selectedMatched: {value: null, label: "Both"},
    cityscopeOptions: [],
    selectedState: null,
    stateOptions: [{value: 'ACT', label: 'ACT'}, {value: 'NSW', label: 'NSW'}, {value: 'NT', label: 'NT'},{value: 'QLD', label: 'QLD'}, {value: 'SA', label: 'SA'}, {value: 'TAS', label: 'TAS'}, {value: 'VIC', label: 'VIC'}, {value: 'WA', label: 'WA'}],
    selectedCategories: null,
    categoryOptions: [{value: 'CO', label: 'CO'},{value: 'BU', label: 'BU'},{value: 'HO', label: 'HO'},{value: 'UN', label: 'UN'} ],
    category: null,
    dataSetPrimaryKey: "draft_sales_feeds_id",
    selectedAgentsAdvice: null,
    agentsAdviceOptions: [{value: true, label: 'Only AA'},{value: false, label: 'Exclude AA'}],
    agentsAdvice: null,
    matchScopeOptions: [{value: 'cityscope', label: 'Match to Cityscope'},{value: 'property', label: 'Match to Property'}],
    selectedMatchScope: {value: 'cityscope', label: 'Match to Cityscope'},
    matchScope: 'cityscope',
};

export default class SalesFeedQueue extends Component {
    constructor(props) {
        super(props);

        this.state = defaultState;
    }
    

    async componentDidMount() {
        console.log("In componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        this.getCityscopes();
        const res  = await this.getFeedDates();


        // const sales = await this.getSales({cityscope: this.state.cityscope,
        //                                         feeddate: this.state.feeddate,                                             
        //                                         state: this.state.state, 
        //                                         matched: this.state.matched, 
        //                                         keyed: this.state.keyed, 
        //                                         saledatefrom: this.state.saledatefrom!==null ? Moment(this.state.saledatefrom).local().format(): null, 
        //                                         saledateto: this.state.saledateto!==null ? Moment(this.state.saledateto).local().format(): null, 
        //                                         salepricefrom: this.state.salepricefrom, 
        //                                         salepriceto: this.state.salepriceto  ,
        //                                         id: this.state.id           
        //                                         });
        // this.setState({ sales });

        
        

        document.title = "Sales Feed Queue";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ agents: [] });        
    }

    async getSales(filter) {
        console.log("Inside getSales() ");
        
        return API.get("colin", "/salesfeed", { 'queryStringParameters': filter});
      
    }

    async getFeedDates() {
        try {
            API.get("colin", `/salesfeed/dropdown`).then((feedDateOptions) => {
                if (feedDateOptions.length>0) {
                    this.setState(state => ({ feedDateOptions: feedDateOptions, selectedFeedDate: feedDateOptions[0], feeddate: feedDateOptions[0].value }));
                    Object.assign(defaultState, { feedDateOptions: feedDateOptions, selectedFeedDate: feedDateOptions[0], feeddate: feedDateOptions[0].value })
                    return true;
                }
            });
        }
        catch{
            console.log("Error getting feed dates");
        }
    }    



    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                    Object.assign(defaultState, { cityscopeOptions: cityscopeOptions })
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    


    handleInputChange = (cellInfo, event) => {
        console.log(event.target.value);
        let sales = [...this.state.sales];
        sales[cellInfo.index][cellInfo.column.id] = event.target.value;
        sales[cellInfo.index].modified = true;
        this.setState({sales});
    };
    handleNumberChange = (cellInfo, event) => {
        let sales = [...this.state.sales];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        sales[cellInfo.index][cellInfo.column.id] = Number(val);
        sales[cellInfo.index].modified = true;
        this.setState({sales});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let sales = [...this.state.sales];
        sales[cellInfo.index][cellInfo.column.id] = event.target.checked;
        sales[cellInfo.index].modified = true;
        if (cellInfo.column.id ==="keyed"){
            sales[cellInfo.index].last_edited_by = this.props.user;
        }
        this.setState({sales}, this.handleSubmit);
    };

    handleDateChange = (cellInfo, event) => {
        let sales = [...this.state.sales];
        sales[cellInfo.index][cellInfo.column.id] = new Date(event);
        sales[cellInfo.index].modified = true;
        this.setState({sales});

    }

    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })

        

    }
    
    handleCityscopeChange = async (selectedCityscope) => {
        if (selectedCityscope){
            this.setState({ selectedCityscope
                ,cityscope: selectedCityscope.map(r=>r.value).join(",")
                , modified: true })
        }
        else{
            this.setState({ selectedCityscope
                ,cityscope: null 
                , modified: true })
        }
    }

    handleStateChange = async (selectedState) => {
        if (selectedState){
            this.setState({ selectedState
                            ,state: selectedState.value 
                            , modified: true })
        }
        else{
            this.setState({ selectedState
                ,state: null 
                , modified: true })
        }
    }

    handleAgentsAdviceChange = async (selectedAgentsAdvice) => {
        if (selectedAgentsAdvice){
            this.setState({ selectedAgentsAdvice
                            ,agentsAdvice: selectedAgentsAdvice.value 
                            , modified: true })
        }
        else{
            this.setState({ selectedAgentsAdvice
                ,agentsAdvice: null 
                , modified: true })
        }
    }

    handleMatchScopeChange = async (selectedMatchScope) => {
        if (selectedMatchScope){
            this.setState({ selectedMatchScope
                            ,matchScope: selectedMatchScope.value 
                            , modified: true })
        }
        else{
            this.setState({ selectedMatchScope
                ,matchScope: null 
                , modified: true })
        }
    }
    handleCategoryChange = async (selectedCategories) => {
        console.log("handleCategoryChange");
        if (selectedCategories){
            this.setState({ selectedCategories
                            ,category: selectedCategories.map(r=>r.value).join(",") 
                            , modified: true })
        }
        else{
            this.setState({ selectedCategories
                ,category: null 
                , modified: true })
        }
    }

    handleFeedDateChange = async (selectedFeedDate) => {
        if (selectedFeedDate){
            this.setState({ selectedFeedDate
                            ,feeddate: selectedFeedDate.value 
                            , modified: true })
        }
        else{
            this.setState({ selectedFeedDate
                ,feeddate: null 
                , modified: true })
        }
    }

    handleMatchedChange = async (selectedMatched) => {
        if (selectedMatched){
            this.setState({ selectedMatched
                            ,matched: selectedMatched.value 
                            , modified: true })
        }
        else{
            this.setState({ selectedMatched
                ,matched: null 
                , modified: true })
        }
    }
    handleKeyedChange = async (selectedKeyed) => {
        if (selectedKeyed){
            this.setState({ selectedKeyed
                            ,keyed: selectedKeyed.value 
                            , modified: true })
        }
        else{
            this.setState({ selectedKeyed
                ,keyed: null 
                , modified: true })
        }
    }


   

    handleSubmit = async event =>{
        event.preventDefault();
        
        try {

            this.setState({isLoading: true});
            const sales = await this.getSales({cityscope: this.state.cityscope,
                                            feeddate: this.state.feeddate!==null ? Moment(this.state.feeddate).local().format('YYYY-MM-DD'): null,                                           
                                            streetname: this.state.streetname,
                                            suburb: this.state.suburb,
                                            state: this.state.state, 
                                            matched: this.state.matched, 
                                            keyed: this.state.keyed, 
                                            saledatefrom: this.state.saledatefrom!==null ? Moment(this.state.saledatefrom).local().format('YYYY-MM-DD'): null, 
                                            saledateto: this.state.saledateto!==null ? Moment(this.state.saledateto).local().format('YYYY-MM-DD'): null, 
                                            salepricefrom: this.state.salepricefrom, 
                                            salepriceto: this.state.salepriceto  ,
                                            transfernumber: this.state.transfernumber,
                                            checkedby: this.state.checkedby,
                                            id: this.state.id ,
                                            category: this.state.category,
                                            agentsAdvice: this.state.agentsAdvice,
                                            matchScope: this.state.matchScope,
                                                    });
            this.setState({ sales });
            this.setState({isLoading: false});
        } catch (e) {
            alert(e);
        }
    }

    handleReset = async event =>{
        event.preventDefault();
        
        try {
            this.setState({isLoading: true}); 
            this.setState(defaultState);
            this.setState({isLoading: false});
        } catch (e) {
            alert(e);
        }
    }

    
    validateRelatedRecord(record, set) {
        
 

        
        return [true,];
    }
    updateTableState(sales, set) {
        
        this.setState({
            [set]: sales
        });
    }


    async saveRecord(record) {
        if (record.keyed){
            record.last_edited_by= this.props.user;
        }
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/salesfeed/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/salesfeed/${record["draft_sales_feeds_id"]}`, {
            body: record
        });
             
    }
    validateRecord(record) {

       
        //Check street name not blank
        // if (record.suburb === "") {
        //     return [false,"Suburb cannot be blank. The record has not been saved"];
        // }
       
        return [true,];
    }


    async handleDataSave(sales) {
        try {
            return await this.saveRecord(sales);


        } catch (e) {
            alert("Error saving");
        }
    }
    
    handleSave = async (cellInfo, event) => {
        
    if (this.state.sales.filter(sale => sale.hasOwnProperty("modified") && sale.modified === true).length>1){
        this.setState({isLoading: true});
    }

        this.setState({ showAlert: false, showWarning: false });
        let sales = [...this.state.sales];
        for (var i=0; i<sales.length; i++){
            
            
            if (sales[i].hasOwnProperty("modified")) {
                if (sales[i].modified === true) {
                    console.log("Is modified");
                    const validation = this.validateRecord(sales[i]);
                    if (validation[0] === true) {
                        console.log("Is valid");
                        
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (sales[i].hasOwnProperty("new_record")) {
                                if (sales[i].new_record === true) {
                                    
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(sales[i]);
                            if (result.result) {
                                sales[i].modified = false;
                                if (sales[i].hasOwnProperty("new_record")) {
                                    if (sales[i].new_record === true) {

                                        sales[i][this.state.dataSetPrimaryKey] = result.id;
                                        sales[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    sales[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (sales[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                this.setState({ savingNewRecord: false });
                return;
            }
        }
    }
        }   
        
        
        this.setState({sales: sales, isLoading: false});

    }
    renderEditable = cellInfo => {
        const cellValue = this.state.sales[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id == "reference_note") {
            return (<div>                                    
                {[{}].concat(this.state.sales[cellInfo.index].cityscopes).map(
                    (d, i) =>
                        i !== 0 && d !==null
                            ?
                            <div>{d.cityscope}<br/></div>
                            : ""
                )}
                
                <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="form-control"
                            value={this.state.sales[cellInfo.index].reference_note !=null? this.state.sales[cellInfo.index].reference_note:""}

                        />
                
            { [{}].concat(this.state.sales[cellInfo.index].properties).map(
                    (d, i) =>
                        i !== 0 && d !==null
                            ?
                            <div><a target="_blank" rel="noopener noreferrer" href={`../properties/${d.property_key}`} >{d.property_key}</a><br/></div>
                            : ""
                )}                                                                                                        
                </div>
                )
           }
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                // onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    async update_Sales()
    {
        let sales = [...this.state.sales];
        for(var i=0;i<sales.length;i++){
            if (sales[i].selected==true){ 
                sales[i].keyed=true;
                sales[i].modified=true;
            }
        }
        this.setState({sales: sales});
        return true
    }

    batchKeyed = async event =>{
        let confirmed = window.confirm("Are you sure you want to batch update all selected records?");
            if (confirmed) {
                this.setState({isLoading: true},this.update_Sales);
                
                
                this.setState({ isLoading: false},this.handleSave);
               
            }
    }

    selectAll = event =>{
        let sales = [...this.state.sales];
        for(var i=0;i<sales.length;i++){
            sales[i].selected=true;
        }
        this.setState({sales});
    }

    deselectAll = event =>{
        let sales = [...this.state.sales];
        for(var i=0;i<sales.length;i++){
            sales[i].selected=false;
        }
        this.setState({sales});
    }

    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }
    renderTable(sales) {
        const formatter = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            currencyDisplay: "symbol"
        })

        const columns = [
            {
                id: 'selected',
                Header: '',
                maxWidth: 30,
                accessor: 'selected',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            }, {
                id: 'draft_sales_feeds_id',
                Header: 'ID',
                maxWidth: 50,
                accessor: 'draft_sales_feeds_id',                
                style: { textAlign: "center" }
            },
            
            {
                id: 'keyed',
                Header: 'Checked',
                maxWidth: 50,
                accessor: 'keyed' ,
                style: { textAlign: "center" },
                Cell: this.renderEditable
        },
        {
            id: 'last_edited_by',
            Header: 'Checked By',            
            accessor: 'last_edited_by',
            maxWidth: 90

        }
        , {
                id: 'created_date',
                Header: 'Feed Date',            
                accessor: 'created_date',
                maxWidth: 80 ,//cut the time off?
                style: { textAlign: "center" },
                accessor: d => {
                    if (d.created_date) {
                        return Moment(d.created_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }

            }
            , {
                id: 'reference_note',
                Header: 'Cityscope',            
                accessor: 'reference_note',
                maxWidth: 100,
                //update link
                //underneath add property_key with link
                Cell: this.renderEditable

            }
            , {
                id: 'category_major_id',
                Header: 'Category',            
                accessor: 'category_major_id',
                maxWidth: 80,
                //add Agents advice
                Cell: row=><div>{row.original.category_major_id} <br/>{row.original.agents_advice && <p class="text-danger">Agents Advice</p>} </div>

            }
            ,
            {
                id: 'unit',
                Header: 'Unit',            
                accessor: 'unit',
                maxWidth: 50

            }
            ,
            {
                id: 'street_address',
                Header: 'Street Address',            
                accessor: 'street_address',
                maxWidth: 200,
                //add suburb, state, pcd on line underneath
                Cell: row=><div>{row.original.street_address} <br/>{row.original.suburb} {row.original.state} {row.original.postcode} </div>,
                style: { 'white-space': 'unset' } 

            },
            {
                id: 'lot_plan',
                Header: 'Title Details',            
                accessor: 'lot_plan',
                maxWidth: 100,
                // Cell: row=><div>{if(row.state !=="ACT"){(row.original.lot_plan||"").replace("/"," / ")} <br/>{(row.original.volume_folio||"").replace("/"," / ")}}  </div>,
                style: { 'white-space': 'unset' } ,
                //add vol/folio
                accessor: d => {
                    if (d.state !=="ACT"){
                        return <div>{(d.lot_plan||"").replaceAll("/"," / ")}<br/>{(d.volume_folio||"").replaceAll("/"," / ")}</div>
                    }// {(d.lot_plan||"").replaceAll("/"," / ")} <br/>
                    else { return <div>{(d.volume_folio||"").replaceAll("/"," / ")}<br/>{(d.rpd||"").replaceAll(":"," : ")}</div> }
                }

            }
            ,
            {
                id: 'sale_date',
                Header: 'Sale Date',            
                accessor: 'sale_date',
                maxWidth: 120,
                //add poss date
                Cell: row =><div>CD: {Moment(row.original.sale_date)
                            .local()
                            .format("DD/MM/YYYY")
                            }                       
                            <br/>
                            TD: {Moment(row.original.poss_date)
                            .local()
                            .format("DD/MM/YYYY")
                            } 
                            </div>

            }
            ,
            {
                id: 'sale_amount',
                Header: 'Sale Price',            
                // accessor: 'sale_amount',
                maxWidth: 100  ,
                accessor: d => {
                    if (d.sale_amount || d.sale_amount==0) {
                        return formatter.format(d.sale_amount )
                    }
                    else { return null }
                }               
            }
            ,
            {
                id: 'sale_code',
                Header: 'Sale Code',            
                accessor: 'sale_code',
                maxWidth: 80                 
            }
            ,
            {
                id: 'transfer_number',
                Header: 'Transfer #',            
                accessor: 'transfer_number',
                maxWidth: 100             ,
                style: { 'white-space': 'unset' }     
            }
            ,
            {
                id: 'vendor',
                Header: 'Buyer Vendor',            
                accessor: 'vendor',
                maxWidth: 250  ,
                Cell: row=><div>Buyer: {row.original.purchaser}<br/> {row.original.purchaser_add1} {row.original.purchaser_add2} {row.original.purchaser_add3} <br/>Vendor: {row.original.vendor}  </div>               ,
                style: { 'white-space': 'unset' } 
            }
            ,
            {
                id: 'agency',
                Header: 'Agency',            
                accessor: 'agency',
                maxWidth: 150  ,
                Cell: row=><div>{row.original.agency}<br/>{row.original.agency_phone && <div>Phone {row.original.agency_phone} </div>}  </div>  ,
                style: { 'white-space': 'unset' }              
            }
            ,
            {
                id: 'attributes',
                Header: 'Attributes',            
                accessor: 'attributes',
                maxWidth: 150          
            }
//           

        ]          

        if (!sales) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={sales}
                    columns={columns}
                    pageSize={100}
                    sortable={true}
                    className="-striped -highlight"
                    id="salesfeedtable"
                    showPaginationTop={true}
                />
            )
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

    
    

    handleSaleDateFromChange = (date) =>{
        if (date) {
            this.setState({
                saledatefrom: new Date(date)
                , modified: true },this.handleBlur);
        }
        else {
            this.setState({
                saledatefrom: null
                , modified: true },this.handleBlur);
        }
        
    }

    handleSaleDateToChange = (date) =>{
        if (date) {
            this.setState({
                saledateto: new Date(date)
                , modified: true },this.handleBlur);
        }
        else {
            this.setState({
                saledateto: null
                , modified: true },this.handleBlur);
        }
        
    }
    
    renderComponent() {
        return (
            <div className="Sales">
                <form onSubmit={this.handleSubmit} onReset={this.handleReset}>
                 <Row className="align-items-end">
                    <Col  sm={2} md={2} lg={2}>
                        <Form.Group   controlId="feeddate" >
                            <Form.Label>Feed Date</Form.Label><br/>
                            <Select
                                value={this.state.selectedFeedDate}
                                onChange={this.handleFeedDateChange}
                                options={this.state.feedDateOptions}
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={2}>
                        <Form.Group controlId="cityscope" >
                            <Form.Label className="text-right" >Cityscope</Form.Label>

                            <Select
                                value={this.state.selectedCityscope}
                                onChange={this.handleCityscopeChange}
                                options={this.state.cityscopeOptions}
                                
                                isMulti
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1.5}>                     
                        <Form.Group controlId="matchscope" >
                            <Form.Label className="text-right" >Match to</Form.Label>

                            <Select
                                value={this.state.selectedMatchScope}
                                onChange={this.handleMatchScopeChange}
                                options={this.state.matchScopeOptions}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2} md={2} lg={1}>                    
                        <Form.Group controlId="matched">
                            <Form.Label className="text-right" >Matched?</Form.Label><br/>

                            <Select
                                value={this.state.selectedMatched}
                                onChange={this.handleMatchedChange}
                                options={[{value: true, label: "Matched"},{value: false, label: "Unmatched"},{value: null, label: "Both"}]}
                            />
                        </Form.Group>
                    </Col >
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="state" >
                            <Form.Label className="text-right" >Category</Form.Label>

                            <Select
                                value={this.state.selectedCategories}
                                onChange={this.handleCategoryChange}
                                options={this.state.categoryOptions}
                                isMulti
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2} md={2} lg={1}>                    
                        <Form.Group controlId="keyed">
                            <Form.Label className="text-right" >Checked?</Form.Label><br/>

                            <Select
                                value={this.state.selectedKeyed}
                                onChange={this.handleKeyedChange}
                                options={[{value: true, label: "Checked"},{value: false, label: "Not Checked"},{value: null, label: "Both"}]}
                                />                          
                        </Form.Group>
                    </Col > 
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="checkedby">
                            <Form.Label className="text-right" >Checked By</Form.Label><br/>

                            <Form.Control
                                type="input"
                                value={this.state.checkedby}
                                onChange={this.handleChange}
                                placeholder="Containing"
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2} md={2} lg={1}>  
                        <Form.Label className="text-right" >ID</Form.Label><br/>

                        <Form.Group controlId="id">
                            <Form.Control
                                value={this.state.id}
                                onChange={this.handleChange}
                                componentClass="input"
                                type="text"
                                placeholder="ID"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="align-items-end">
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="streetname">
                            <Form.Label className="text-right" >Street Name</Form.Label><br/>

                            <Form.Control
                                type="input"
                                value={this.state.streetname}
                                onChange={this.handleChange}
                                placeholder="Containing"
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="suburb">
                            <Form.Label className="text-right" >Suburb</Form.Label><br/>

                            <Form.Control
                                type="input"
                                value={this.state.suburb}
                                onChange={this.handleChange}
                                placeholder="Containing"
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="state" >
                            <Form.Label className="text-right" >State</Form.Label>

                            <Select
                                value={this.state.selectedState}
                                onChange={this.handleStateChange}
                                options={this.state.stateOptions}
                                
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2} md={2} lg={1}> 
                        <Form.Group   controlId="saledatefrom" >
                            <Form.Label>Sale Date From</Form.Label><br/>

                            <DatePicker
                                selected={this.state.saledatefrom}
                                onChange={this.handleSaleDateFromChange}
                                name="saledatefrom"
                                onBlur={this.handleSave}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                isClearable={true}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2} md={2} lg={1}> 
                        <Form.Group   controlId="saledateto" >
                            <Form.Label>Sale Date To</Form.Label><br/>

                            <DatePicker
                                selected={this.state.saledateto}
                                onChange={this.handleSaleDateToChange}
                                name="saledateto"
                                
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                isClearable={true}
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="salepricefrom">
                            <Form.Label className="text-right" >Sale Price From</Form.Label><br/>

                            <Form.Control
                                type="input"
                                value={this.state.salepricefrom}
                                onChange={this.handleChange}
                                placeholder=""
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="salepriceto">
                            <Form.Label className="text-right" >Sale Price To</Form.Label><br/>

                            <Form.Control
                                type="input"
                                value={this.state.salepriceto}
                                onChange={this.handleChange}
                                placeholder=""
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1}>
                        <Form.Group controlId="transfernumber">
                            <Form.Label className="text-right" >Transfer #</Form.Label><br/>

                            <Form.Control
                                type="input"
                                value={this.state.transfernumber}
                                onChange={this.handleChange}
                                placeholder="Containing"
                            />
                        </Form.Group>
                    </Col>
                    <Col  sm={2} md={2} lg={1} >                     
                        <Form.Group controlId="agentsadvice" >
                            <Form.Label className="text-right" >Agents Advice</Form.Label>

                            <Select
                                value={this.state.selectedAgentsAdvice}
                                onChange={this.handleAgentsAdviceChange}
                                options={this.state.agentsAdviceOptions}
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col id="salesForm">
                        <Button type="submit" variant="primary">Search</Button>{" "}
                        <Button type="reset">Reset</Button>
                    </Col>
                    </Row> 
                    </form>
                    <Row>
                        <Col  id="salesForm">
                    <Nav className="justify-content-start"  id="salesFormSelectAll">
                             <Nav.Item  >
                            <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                           </Nav.Item> <Nav.Item  >
                             <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                             </Nav.Item> 
                             <Nav.Item  >
                             <Button variant="primary" type="button" size="sm" onClick={this.batchKeyed}>Batch Update Checked</Button>{" "}
                             </Nav.Item> 
                            </Nav>
                             </Col>
                             
                    </Row>
                    <Row>
                        <Col><b>{this.state.sales?this.state.sales.length: "0"} of {this.state.sales? this.state.sales.length>0 ? this.state.sales[0].result_count: "0":"0"} records available.</b></Col>
                    </Row>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12} style={{ 'font-size': '120%' }} >
                     
                        {!this.state.isLoading ? this.renderTable(this.state.sales) : this.renderPacman()  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
    
  render() {
    return (

        <div className="SalesList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
